<template>
  <div>
    <div class="wd-mb-6">
      <p class="wd-text-base !wd-mb-0">{{ $t('create_account_title') }}</p>
    </div>

    <MemberConsentCheckboxes v-model="userContract" />

    <v-btn class="wd-mt-6" color="orange50" variant="flat" block :loading="loading" :disabled="!isConsentValid" @click="handleConfirm">
      {{ $t('create_account') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import MemberConsentCheckboxes from '@/components/login/MemberConsentCheckboxes.vue'
import { useMemberConsent } from '@/composition/useMemberConsent'

defineProps<{
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'confirm', value: { isTermsAccepted: boolean; isMarketingAllowed: boolean }): void
}>()

const { userContract, isConsentValid, createConfirmHandler } = useMemberConsent()

const handleConfirm = createConfirmHandler(contract => {
  emit('confirm', contract)
})
</script>
